import styled, { css } from 'styled-components'
import { Col } from 'react-styled-flexboxgrid'
import { P, Section } from '../Globals/index.style'
import Button from '../Button/index'

export const SubText = styled(P)`
  margin: 0 auto;
  max-width: 768px;
`

export const CardSection = styled(Section)`
  flex-basis: 100%;
  max-width: 100%;
  display: block;
  background: none;
  padding: 0;
`

export const StyledCol = styled(Col)`
  margin: 0 auto;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    margin: 0;
    padding: 24px;
  }
`

export const CardLink = styled.article`
  text-decoration: none;
`

export const CardCtabtn = styled(Button)`
  display: flex;
  border: none;
  min-width: 220px;
  justify-content: center;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
`

export const TextHighlight = styled(P)`
  span {
    ${({ highlight }) =>
      highlight &&
      css`
        background: #142201;
        color: #ffffff;
        display: flex;
        padding: 10px;
        font-weight: 700;
        text-transform: uppercase;
        border-radius: 4px;
      `}
  }
`
